import script from "./SalesAnalysisDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesAnalysisDashboard.vue?vue&type=script&setup=true&lang=js"

import "./SalesAnalysisDashboard.vue?vue&type=style&index=0&id=0b546216&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b546216"]])

export default __exports__